import React, { useEffect } from "react";
import { Container, } from "react-bootstrap";
import { connect } from "react-redux";
import { DeleteInvoiceApi, PrintInvoicePDF } from "./InvoiceAction";
import { baseURL, headers } from "../../../../../global/api";
import { setHeading } from "../../../accounts/account.actions";
import { changeDateFormate, PDFHeader } from "../../../../../global/globalFunctions";
import MaterialTable from "material-table";
import PrintIcon from '@mui/icons-material/Print';
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
const tableRef = React.createRef()


const ViewInvoice = (props) => {
    const permissions = JSON.parse(window.localStorage.getItem("permissions"));
    const Checkpermissions = (permissionsType, permissionsName) => {
        return permissions.some((p) => p[`${permissionsType}`] === permissionsName) ? false : true;
    };

    useEffect(() => {
        props.setHeading("Invoice List");
    }, []);

    return (
        <>
            <Container fluid>
                <MaterialTable
                    tableRef={tableRef}
                    title="Invoice Details"
                    columns={[
                        { title: 'S.No', field: 'sequenceNumber', editable: 'never' },
                        { title: "Date", field: "invoiceDate", render: (rowData) => changeDateFormate(rowData.invoiceDate) },
                        { title: "Customer", field: "customerDetails.customerName", editable: 'never' },
                        { title: "Manual Invoice No", field: "manualInvoiceNumber" },
                        { title: "Remarks", field: "remarks" },
                        { title: "Invoice Total", field: "invoiceTotal" },
                        { title: "Created By", field: "userDetails.userName", editable: 'never' },
                    ]}
                    detailPanel={(rowData) => {
                        return (
                            <MaterialTable
                                columns={[
                                    { title: "Product Name", field: "item" },
                                    { title: "Sale Price", field: "salePrice" },
                                    { title: "Quantity", field: "quantity" },
                                    { title: 'Total Price', field: 'totalPrice' },
                                ]}
                                data={rowData.data}
                                options={{
                                    toolbar: false,
                                    search: false,
                                    actionsColumnIndex: -1,
                                    exportButton: false,
                                    exportAllData: false,
                                    paging: false,
                                    pageSize: 50,
                                    emptyRowsWhenPaging: false,
                                    pageSizeOptions: [50, 100, 150, 200],
                                    headerStyle: {
                                        position: "sticky",
                                        top: 0,
                                        color: "#00BBBB",
                                        fontWeight: "550",
                                        fontSize: "14px",
                                    },
                                    rowStyle: (rowData, index) => ({
                                        backgroundColor: "#ededed",
                                        // fontWeight: rowData.accountType === 1 ? "bold" : "normal",
                                        color: "black"
                                    }),
                                }}
                            />
                        );
                    }}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            let url = `${baseURL}/invoice/get-invoice?`;
                            url += "limit=" + query.pageSize;
                            url += "&page=" + (query.page);
                            url += "&search=" + query.search;
                            fetch(url, {
                                method: "GET",
                                headers: headers,
                            }).then((response) => response.json()).then((result) => {
                                resolve({
                                    data: result.data,
                                    page: result.page,
                                    totalCount: result.total_results,
                                });
                            });
                        })
                    }
                    options={{
                        actionsColumnIndex: -1,
                        exportButton: true,
                        exportAllData: true,
                        paging: true,
                        pageSize: 50,
                        emptyRowsWhenPaging: false,
                        pageSizeOptions: [50, 100, 150, 200],
                        headerStyle: {
                            position: "sticky",
                            top: 0,
                            color: "#00BBBB",
                            fontWeight: "550",
                            onRowAdd: "none",
                        },
                        exportPdf: (columns, data) => {
                            const unit = "pt";
                            const size = "A4";
                            const orientation = "l";
                            const doc = new jsPDF(orientation, unit, size);
                            PDFHeader(doc, "Invoice Details");

                            const columnTitles = columns.map(columnDef => columnDef.title);
                            const pdfData = data.map((elt) => [
                                elt.sequenceNumber,
                                elt.invoiceDate,
                                elt.customerDetails.customerName || '',
                                elt.manualInvoiceNumber,
                                elt.remarks,
                                elt.invoiceTotal,
                                elt.userDetails.userName,
                            ]);
                            let content = {
                                startY: 120,
                                startX: 5,
                                head: [columnTitles],
                                body: pdfData,
                                headStyles: { fillColor: "#2980ba", font: 'Amiri', fontSize: 10 },
                                styles: { fontSize: 9 },
                                theme: "grid",
                            };

                            doc.setFontSize(11)
                            doc.setFont("Times New Roman", "Normal")
                            doc.autoTable(content);

                            doc.setProperties({ title: 'Invoice Details' })
                            doc.output('dataurlnewwindow')
                        },
                    }}
                    actions={[
                        {
                            icon: 'refresh',
                            tooltip: 'Refresh Data',
                            isFreeAction: true,
                            onClick: () => tableRef.current && tableRef.current.onQueryChange(),
                        },
                        (rowData) => ({
                            icon: () => <PrintIcon style={{ color: '#1D1D1D' }} />,
                            tooltip: "Print Voucher",
                            onClick: (event, rowData) => {
                                props.PrintInvoicePDF(rowData)
                            },
                        }),
                    ]}
                    editable={{
                        isEditable: (rowData) => false,
                        // isEditHidden: (rowData) => Checkpermissions("permissionsSubCatName", "Invoice Edit"),
                        isDeleteHidden: (rowData) => Checkpermissions("permissionsSubCatName", "Invoice Delete"),
                        onRowUpdate: (newData, oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    // props.UpdateMachineApi(newData, oldData);
                                }, 600);
                            }),
                        onRowDelete: (oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    props.DeleteInvoiceApi(oldData._id);
                                }, 600);
                            }),
                    }}
                    icons={{
                        Edit: (props) => <EditIcon {...props} />,
                        Delete: (props) => <DeleteOutlineIcon {...props} style={{ color: "#DC3545" }} />
                    }}
                />
            </Container>
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        DeleteInvoiceApi: (id) => dispatch(DeleteInvoiceApi(id)),
        // UpdateMachineApi: (newData, oldData) => dispatch(UpdateMachineApi(newData, oldData)),
        setHeading: (data) => dispatch(setHeading(data)),
        PrintInvoicePDF: (data) => dispatch(PrintInvoicePDF(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isFetchingInvoice: state.InvoiceReducer.isFetchingInvoice,
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewInvoice);